import { render, staticRenderFns } from "./diveCenterList.vue?vue&type=template&id=9c80f168&scoped=true&"
import script from "./diveCenterList.vue?vue&type=script&lang=js&"
export * from "./diveCenterList.vue?vue&type=script&lang=js&"
import style0 from "./diveCenterList.vue?vue&type=style&index=0&id=9c80f168&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9c80f168",
  null
  
)

export default component.exports